import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import LogoSVG from "./LogoSVG";

const LINKS = [
  ["/",           "Home"],
  ["/about",      "About"],
  ["/news",       "News"],
  ["/projects",   "Projects"],
  ["/landowners", "Members"],
  ["/contact",    "Contact"],
];

export default function Navbar({ isAdmin, onLogout }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate  = useNavigate();
  const location  = useLocation();

  const go = path => {
    navigate(path);
    setMenuOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const isOn = path =>
    path === "/" ? location.pathname === "/" : location.pathname.startsWith(path);

  return (
    <nav className="nav">
      <div className="nav-brand" onClick={() => go("/")}>
        <LogoSVG size={44}/>
        <div className="nav-brand-txt">
          <div className="t1">LHDA Inc.</div>
          <div className="t2">Lomban Hydropower Development Association</div>
        </div>
      </div>

      <button
        className={`nav-hamburger${menuOpen ? " open" : ""}`}
        onClick={() => setMenuOpen(o => !o)}
        aria-label="Toggle menu"
      >
        <span/><span/><span/>
      </button>

      <div className={`nav-links${menuOpen ? " open" : ""}`}>
        {LINKS.map(([path, label]) => (
          <button key={path} className={`nl${isOn(path) ? " on" : ""}`} onClick={() => go(path)}>
            {label}
          </button>
        ))}
        {isAdmin
          ? <button className="nav-cta out" onClick={() => { onLogout(); setMenuOpen(false); navigate("/"); }}>Sign Out</button>
          : <button className="nav-cta" onClick={() => go("/login")}>Admin</button>
        }
      </div>
    </nav>
  );
}
